import React from 'react';
import PropTypes from 'prop-types';
import BarChartWithThreshold from './BarChartWithThreshold';
import { chartTheme } from './chartTheme';

const BarChartAssignmentAverages = ({ data }) => {
  return (
    <BarChartWithThreshold
      data={data}
      title="Assignment Performance by Section"
      description={`
        This chart displays the <b style="color:${chartTheme.main};">average scores</b> for the assignment 
        <b style="color:${chartTheme.secondary};">${data?.sections?.[0]?.assignmentName}</b> across different sections. 
        Only sections under the requested <b style="color:red;">${data.numericPercentage}%</b> average are represented.
        The <b style="color:red;">dotted line</b> indicates that threshold.
      `}
      series={[
        {
          dataKey: 'averagePercentage',
          name: 'Average Percentage',
          color: chartTheme.secondary,
        },
      ]}
      threshold={data?.numericPercentage}
    />
  );
};

export default BarChartAssignmentAverages;

BarChartAssignmentAverages.propTypes = {
  data: PropTypes.shape({
    sections: PropTypes.array,
    numericPercentage: PropTypes.number,
  }).isRequired,
};
